import TableVM from 'libs/table';
export default function (data) {
  var self = this;
  self.table = ko.observable();
  self.allResources = ko.observableArray();
  self.resources = ko.observableArray();

  self.bindData = function(data) {
    self.coupon_access = data.coupon_access;
    self.resources(data.resources);
    self.allResources(data.resources);
  };

  self.initTable = function() {
    var params = {
      removable: {
        enabled: true
      },
      coupon_access: self.coupon_access,
      dataset_name: 'resources'
    };
    var el = document.getElementById('resource-table');
    self.table(new TableVM(data, el, params));
    ko.applyBindingsWithValidation(self.table(), el, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorResourceIndexViewModel');
    that.bindData(data);
    that.initTable();
  }(this);
}
